const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b68b11fe7134e682507118dafe272efaa87ec8a8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["in-the-pouch@long-forme"]={id:"b68b11fe7134e682507118dafe272efaa87ec8a8"};
      